import React, {
	Dispatch,
	SetStateAction,
	useState,
	useRef,
	useEffect,
} from 'react';
import AddFilterButton from '../../Buttons/AddFilterButton';
import s from './CalculatedTable.module.css';
import TableSvgSelector from './TableSvgSelector';
import {Link} from 'react-router-dom';
import MyAccountsFilterNew from '../../Filter/MyAccountsFilterNew';
import {RequestPremiaType} from '../../../types/TypesUserAccounts';
import {formatNumber} from '../../../assets/utils/utils';
import {useTranslation} from 'react-i18next';

type Props = {
	title: string;
	buttonName: string;
	type: 'OPTIMA' | 'PersonalVolume' | 'Cashback';
	data: any;
	text_points?: string;
	PersonalVolume_mounth?: string;
	setFilters: Dispatch<SetStateAction<RequestPremiaType>>;
	shouldScroll?: boolean;
	onScrolled?: () => void;
	onFilterApplied?: () => void;
};
const CalculatedTable: React.FC<Props> = ({
	title,
	buttonName,
	type,
	data,
	text_points,
	PersonalVolume_mounth,
	setFilters,
	shouldScroll,
	onScrolled,
	onFilterApplied,
}) => {
	const [active, setActive] = useState(false);
	const filterContainerRef = useRef<HTMLDivElement>(null);
	const {t} = useTranslation();
	useEffect(() => {
		if (shouldScroll && filterContainerRef.current && data) {
			const timeoutId = setTimeout(() => {
				filterContainerRef.current?.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});
				onScrolled?.();
			}, 300);
			return () => clearTimeout(timeoutId);
		}
	}, [shouldScroll, data, onScrolled]);

	return (
		<div className={s.container}>
			<div className={s.title}>{title}</div>
			<div className={s.topPanel}>
				<div className={s.filterContainer} ref={filterContainerRef}>
					<AddFilterButton
						setFilterMenu={setActive}
						filterMenu={active}
						color={'blue'}
					/>
					<MyAccountsFilterNew
						active={active}
						setActive={setActive}
						type={type}
						setFilters={setFilters}
						onFilterApplied={onFilterApplied}
					/>
				</div>

				{type === 'OPTIMA' && (
					<div className={s.total}>{data.sum_optima_money_currency ?? 0}</div>
				)}
				{type === 'PersonalVolume' && (
					<div className={s.total}>
						{data.bonus_money ? formatNumber(data.bonus_money) : 0}
					</div>
				)}
				{type === 'Cashback' && (
					<div className={s.total}>{data.sum_active_money_currency ?? 0}</div>
				)}
			</div>

			<div className={s.itemsContainer}>
				{(type === 'OPTIMA' || type === 'Cashback') && !data.orders && (
					<div className={s.greenButtonContainer}>
						{t('За вказаний період дані відсутні')}
					</div>
				)}
				{type === 'OPTIMA' &&
					data.orders?.map((information: any) => {
						return (
							<div key={information.id} className={s.item}>
								<div className={s.itemNumberOptima}>{information.order_id}</div>
								<div className={s.itemPerson}>{information.name}</div>
								<div className={s.itemMoney}>
									{information.active_money_currency}
								</div>
								<div className={s.itemReward}>
									{information.optima_money_currency}
								</div>
							</div>
						);
					})}
				{type === 'PersonalVolume' && (
					<Link
						to={
							'/my_bonus' +
							(data.bonus_month ? '?month=' + data.bonus_month : '')
						}
						className={s.itemPersonalValue}
					>
						<div className={s.itemPersonalValueNumber}></div>
						<div className={s.itemPersonalValueVolume}>{buttonName}</div>
						<div className={s.itemPersonalValueReward}>
							{data.bonus_money ? formatNumber(data.bonus_money) : 0}
						</div>
					</Link>
				)}
				{type === 'Cashback' &&
					data.orders?.map((information: any) => {
						return (
							<Link
								key={information.id}
								to={'/my_orders?order_id=' + information.order_id}
								className={s.item}
							>
								<div className={s.cashbackInfo_Date}>
									{information.cashback_date}
								</div>
								<div className={s.itemPerson}>ID {information.order_id}</div>
								<div className={s.cashbackInfo}>
									<TableSvgSelector id={'cashback$'} />
									<span className={s.cashbackInfo_Title}>сashback</span>
									<span className={s.cashbackInfo_Sum}>
										{information.cashback_money_currency}
									</span>
								</div>
								<div className={s.itemReward}>
									{information.sum_cashback_money_currency}
								</div>
							</Link>
						);
					})}
			</div>
			{/*<div className={s.hideItems}>
                <div className={s.item}>
                    <div className={s.itemNumber}>1</div>
                    <div className={s.itemPerson}>Кривошапко Елена</div>
                    <div className={s.itemMoney}>2 400</div>
                    <div className={s.itemReward}>720</div>
                </div>
            </div>
            <div className={s.greenButtonContainer}>
                    <LightGreenButton text={buttonName} />
            </div>*/}
		</div>
	);
};

export default CalculatedTable;
